<div class="modal-backdrop" data-cy="confirm-dialog">
  <div
    class="dc-confirm-dialog"
    [class.dc-confirm-dialog--alert]="dialog.hideCancel && !dialog.showCloseButton"
    role="dialog"
    tabindex="0"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    (keydown.space.prevent)="$event.stopPropagation()"
  >
    <header>
      @if (dialog.title) {
        <h2>{{ dialog.title }}</h2>
      }
      @if (!dialog.hideCancel || dialog.showCloseButton) {
        <button type="button" class="icon-button" (click)="cancel()" aria-label="Close">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      }
    </header>
    <div class="confirm-body">
      <p>{{ dialog.message }}</p>
    </div>
    <footer>
      @if (!dialog.hideCancel) {
        <button type="button" class="button button-quiet" data-cy="confirm-dialog-cancel" (click)="cancel()">
          {{ dialog.cancelText }}
        </button>
      }
      <button type="button" [class]="confirmClass()" data-cy="confirm-dialog-confirm" (click)="confirm()">
        {{ dialog.confirmText }}
      </button>
    </footer>
  </div>
</div>
